import React, { useState } from 'react'
import {
  Box,
  Link,
  Paper,
  IconButton,
  Typography,
  InputAdornment,
} from '@mui/material'
import { CommonTextField, CommonButton } from '@/components/common'
import { useChairpersonContext } from '@/context'
import { useChairpersonLogin } from '@/hooks'
import { VisibilityIcon, VisibilityOffIcon } from '@/icons'
import { forcyteService } from '@/services'

export const ChairpersonLoginForm = ({ onSuccess, onAccountRecovery }) => {
  const { getChairperson } = useChairpersonContext()
  const { loadingLogin, login } = useChairpersonLogin()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  const handleLogin = async e => {
    if (e) e.preventDefault()
    setError('')

    try {
      const response = await login({ email, password })
      if (response && response.token) {
        forcyteService.setToken(response.token, response.token_expiry)
        forcyteService.refresh()
        await getChairperson()
        onSuccess()
      }
    } catch (error) {
      setError('Invalid email or password')
    }
  }

  return (
    <Paper
      sx={{
        p: { xs: 3, md: 5 },
        width: '100%',
        maxWidth: 540,
        borderRadius: 2,
      }}
    >
      <Box
        component='form'
        onSubmit={handleLogin}
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 3,
        }}
      >
        <Typography
          variant='h4'
          sx={{
            textAlign: 'center',
            mb: 2,
          }}
        >
          Chairperson Login
        </Typography>

        <CommonTextField
          id='email'
          label='Email'
          value={email}
          setValue={setEmail}
          type='email'
          error={error}
          placeholder='Enter your email'
          inputProps={{
            name: 'email',
            autoComplete: 'username email',
          }}
        />

        <CommonTextField
          id='password'
          label='Password'
          value={password}
          setValue={setPassword}
          type={showPassword ? 'text' : 'password'}
          error={error}
          placeholder='Enter your password'
          inputProps={{
            name: 'password',
            autoComplete: 'current-password',
          }}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={e => e.preventDefault()}
                    edge='end'
                    size='small'
                  >
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
          labelRight={
            <Link
              onClick={onAccountRecovery}
              sx={{
                fontSize: '0.875rem',
                cursor: 'pointer',
                textDecoration: 'none',
                color: 'primary.main',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              Login without password
            </Link>
          }
        />

        <CommonButton
          id='login-button'
          label='Log In'
          type='submit'
          onClick={handleLogin}
          loading={loadingLogin}
          disabled={!email || !password}
          size='large'
          style={{ width: '100%' }}
        />

        <Typography variant='body1'>
          Haven't claimed your account yet? Click{' '}
          <Link sx={{ cursor: 'pointer' }} onClick={onAccountRecovery}>
            here
          </Link>
        </Typography>
      </Box>
    </Paper>
  )
}
